export const ZOOM_LEVELS = ['100', '110', '125', '150', '175', '200'];
